import modeEnum from "Areas/Documents/documentEditorPanel/mode";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import head from "lodash/head";
import keyBy from "lodash/keyBy";
import reject from "lodash/reject";
import { NAMESPACE, NEW_FOLDER } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        folders: {},
        selectedFolderId: {},
        selectedFileId: {},
        files: {},
        mode: undefined
    }
};
export default createReducer(initialState, {
    [actionTypes.SET_FILES]: (state, { meta }) => set(state, `[${NAMESPACE}].files[${meta.folderId}]`, meta.files),
    [actionTypes.SET_FOLDERS]: (state, { meta }) => set(state, `[${NAMESPACE}].folders[${meta.documentId}]`, meta.folders),
    [actionTypes.UNSET_FOLDER]: (state, { folderId, documentId }) => set(state, `[${NAMESPACE}].folders[${documentId}][${folderId}].Deleted`, true),
    [actionTypes.UNSET_FILE]: (state, { fileId, folderId }) => set(state, `[${NAMESPACE}].files[${folderId}][${fileId}].Deleted`, true),
    [actionTypes.SET_FOLDER]: (state, { folder }) => set(state, `[${NAMESPACE}].folders[${folder.DocumentId}][${folder.Id}]`, folder),
    [actionTypes.SET_FILE]: (state, { file }) => set(state, `[${NAMESPACE}].files[${file.FolderId}][${file.Id}]`, file),
    [actionTypes.SET_SELECTED_FOLDER]: (state, { selectedFolderId, documentId }) => set(state, `[${NAMESPACE}].selectedFolderId[${documentId}]`, selectedFolderId),
    [actionTypes.SET_SELECTED_FILE]: (state, { selectedFolderId, documentId, fileId }) => set(state, `[${NAMESPACE}].selectedFileId[${documentId}][${selectedFolderId}]`, fileId),
    [actionTypes.SET_MODE_AND_DOCUMENT_ID]: (state, { folderId, mode }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            folderId: mode === modeEnum.CREATE ? NEW_FOLDER.Id : folderId,
            mode
        }
    }),
    [actionTypes.SAVE_FOLDER_COMPLETED]: (state, { payload }) => {
        let result = set(state, `[${NAMESPACE}].folders[${payload.DocumentId}][${payload.Id}]`, payload);
        result = set(result, `[${NAMESPACE}].selectedFolderId[${payload.DocumentId}]`, payload.Id);
        result = set(result, `[${NAMESPACE}].mode`, undefined);
        result = set(result, `[${NAMESPACE}].folders[${payload.DocumentId}][${payload.Id}]`, payload);
        return result;
    },
    [actionTypes.DELETE_FOLDER_COMPLETED]: (state, { meta }) => {
        let result = set(state, `[${NAMESPACE}].folders[${meta.documentId}][${meta.folderId}].Deleted`, true);
        const folders = reject(result[NAMESPACE].folders[meta.documentId], "Deleted");
        const headFolder = head(folders);
        result = set(result, `[${NAMESPACE}].selectedFolderId[${meta.documentId}]`, headFolder === null || headFolder === void 0 ? void 0 : headFolder.Id);
        return result;
    },
    [actionTypes.DELETE_FILE_COMPLETED]: (state, { meta }) => {
        let result = set(state, `[${NAMESPACE}].files[${meta.folderId}][${meta.fileId}].Deleted`, true);
        const files = reject(result[NAMESPACE].files[meta.folderId], "Deleted");
        const headFile = head(files);
        result = set(result, `[${NAMESPACE}].selectedFileId[${meta.folderId}]`, headFile === null || headFile === void 0 ? void 0 : headFile.Id);
        return result;
    },
    [actionTypes.GET_FILES_COMPLETED]: (state, { meta, payload }) => set(state, `[${NAMESPACE}].files[${meta.folderId}]`, keyBy(payload, "Id")),
    [actionTypes.GET_FOLDERS_COMPLETED]: (state, { payload, meta }) => set(state, `[${NAMESPACE}].folders[${meta.documentId}]`, keyBy(payload, "Id"))
});
